// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import { SequenceNumber } from './common/SequenceNumber/SequenceNumber'
import { Status } from './common/Status/Status'

import styles from './TabContent.module.scss'

export const TabContent = ({
  className = undefined,
  label,
  sequenceNumber,
  isActive,
  isDisabled,
  isFinished,
  isInvalid,
}) => (
  <span className={cx(styles.content, { [className]: Boolean(className) })}>
    {sequenceNumber ? (
      <SequenceNumber {...{ sequenceNumber, isActive, isDisabled }} />
    ) : null}
    <span
      className={cx(styles.label, {
        [styles.disabled]: isDisabled,
        [styles.active]: isActive,
        [styles.invalid]: isInvalid,
      })}
    >
      {label}
    </span>
    <Status {...{ isFinished, isInvalid }} />
  </span>
)
